import { defineStore } from "pinia";
import { v4 as uuidv4 } from "uuid";
export const useVoixStudioStore = defineStore("voixStudioStore", () => {
  const currentAdminId = uuidv4();
  return {
    currentAdminId
  };
});
